import React, { FC } from 'react';
import Modal, { ModalProps } from 'components/shared/Modal';
import { ASSETS } from 'constants/assets';
import Link from 'components/shared/Link';
import { useTranslation } from 'react-i18next';

type Props = Omit<ModalProps, 'children'>;

const SettingUpLinkOwnershipModal: FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <Modal size="lg" {...props}>
      <Modal.Header title={t('settingUpLinkOwnership')} />
      <Modal.Content>
        <video
          src={ASSETS.settingUpLinkOwnership}
          width="100%"
          height="auto"
          controls
        />
      </Modal.Content>
      <Modal.Footer className="tw-justify-start">
        <Link
          target="_blank"
          to={ASSETS.howToEditFBLinkOwnership}
          className="tw-text-primary-100"
        >
          <span>{t('seeFacebookGuideline')}</span>
        </Link>
      </Modal.Footer>
    </Modal>
  );
};

export default SettingUpLinkOwnershipModal;
